import {getSelectedOptions} from "./ui/filters";
import {fetchStores} from "./api/fetchStores";
import {createMap} from "./map/createMap";
import {createMarkers} from "./map/createMarkers";
import {createMarkerClusterer} from "./map/markerClusterer";
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import {initAutocomplete} from "./ui/autocomplete";
import {handleForm} from "./form/handleForm";
import type {Store} from "./types";

export default async function storeLocator() {

    const mapElement = document.getElementById("sl-map") as HTMLElement;
    if (!mapElement) return;

    const map = await createMap();
    let markers: google.maps.Marker[] = [];
    let bounds = new google.maps.LatLngBounds();
    let clusterer: MarkerClusterer | null = null;

    const selects = {
        region: document.getElementById("sl-region") as HTMLSelectElement,
        product: document.getElementById("sl-product") as HTMLSelectElement,
        testimonial: document.getElementById("sl-type_testimonial") as HTMLSelectElement,
    };

    const params = {
        region: getSelectedOptions(selects.region),
        product: getSelectedOptions(selects.product),
        type_testimonial: getSelectedOptions(selects.testimonial),
    };

    const stores: Store[] = await fetchStores(params);
    if (stores.length > 0) {
        createMarkers(map, markers, bounds, stores);
        if (markers.length > 1) {
            clusterer = createMarkerClusterer(map, markers);
        }
    }

    // Filtering
    Object.values(selects).forEach((el) =>
        el.addEventListener("change", async () => {
            clusterer = await handleForm(map, markers, clusterer, bounds, selects);
        })
    );

    // Autocomplete
    initAutocomplete(async () => {
        clusterer = await handleForm(map, markers, clusterer, bounds, selects);
    });
}
